import { SHOPPING_MODE } from '../helpers/contants';

export interface routeTypes {
  name: string;
  path: string;
  id: number;
  isPrivate?: boolean;
  Component: React.FC<any>;
  pageProp?: { page: string };
}

export interface country {
  code: string;
  dial_code: string;
  flag: string;
  name: string;
  _id: string;
}
export interface CustomKeys {
  label: string;
  value: string;
}

export interface Department {
  _id: string;
  deptName: string;
}

export enum OrderSortKeys {
  updatedAt = 'updatedAt',
  userName = 'userName',
}
export enum BannerSortKeys {
  created = 'created',
  bannerTitle = 'bannerTitle',
}

export enum ConfigurationSortKeys {
  empName = 'empName',
  roleName = 'roleName',
  deptName = 'deptName',
  categoryName = 'categoryName',
  created = 'created',
  universityName = 'universityName',
  companyName = 'companyName',
  degreeName = 'degreeName',
}
export interface CommonState {
  countryList: country[];
  departmentList: Department[];
  categories: any[];
  loading: boolean;
  assosiatedList: any;
  page: number;
  orderListDept: any;
  searchedLocations: any[];
  filterapplied: boolean;
  searchParamsForProduction: string;
  searchParamsForEpisode: string;
  menu: boolean;
  deptList: any;
  positionList: any;
  selectedTalentUser: any;
  presignedSignedUrl: any;
  selectedProductionId: any;
  emailunique: any;
  departmentSignUplist: any;
  departmentAddContact: any;
  roleList: any;
  UserListSignUp: any;
  selectedStudio: any;
  selectedEpisode: any;
  studioCards: any;
  selectedLocation: any;
  selectedSet: any;
  selectedProduction: any;
  selectedTabValue: number;
  deptLists: any;
  permissionsData: any;
  selectedAddress: any;
  unreadCount: number;
  profileData: any;
  selectedEntity: any;
  breadcrumbs: any;
  accordian: boolean;
  accessDashboards: any;
  userPermissionData: any;
  accountControl: any;
  selectedTab: number;
  spendingBreadcrumbs: any[];
  selectedProd: any;
  previewShiftDetails: any;
  addMoreItems: any;
  startOrderData: any;
  selectedEntityType: string;
  riskBreadcrumbs: any[];
  loggedInMemberType: string;
  isRiskAnalystUser: boolean;
  verifyOtpLoading: boolean;
  manageEntitiesPicker?: {
    productionData: any[];
    episodesPagedData: any[];
    setsPagedData: any[];
    locationsPagedData: any[];
    productionsLoading: boolean;
    episodesLoading: boolean;
    setsLoading: boolean;
    locationsLoading: boolean;
  };
}

export interface StudioState {
  loading: boolean;
  commission: null | any;
  error: boolean | string;
  vendorsLists: null | any;
  type: number;
  studio: any;
  studioDetail: any;
  studiolist: any;
  pageNo: number;
  studiolistactive: any;
  studiolistinactive: any;
  studiolistupcoming: any;
  studioSpendingGraph: any;
  graphLoader: boolean;
  allStudiolist: any;
  studioSpendingLists: any;
  studioLocations: any;
  studioProductionLocations: any;
  studioOrders: any;
  studioFormData: any;
  contacts: any;
  entityDeps: any;
  studioRoleList: any;
  roleDetails: any;
  entityCount: any;
  contactDetails: any;
}

export interface DashboardState {
  loading: any;
  studioList: any;
  productionList: any;
  setList: any;
  episodeList: any;
  locationList: any;
  studioSpendingGraph: any;
  spendings?: any;
  contacts?: any;
  selectedStudio?: any;
  selectedProduction: any;
  selectedLocation: any;
  selectedSet: any;
  selectedEpisode: any;
  entityDetail: any;
  dashboardPiaChart: any;
  dailyDeptSpendings: any;
  departmentLineGraphData: any;
  departmentPaiChartData: any;
  approvers: any;
  dashboardPieChartData: any;
}

export interface ProductionState {
  productiondetails: any;
  departmentlist: any;
  crewmemberlist: any;
  relatedsets: any;
  setlist: any;
  loadingmember: any;
  documentlist: any;
  contactlist: any;
  crewDoc: any;
  setorder: any;
  memberDetails: any;
  orderlist: any;
  productionTableList: any;
  productionSpendingGraph: any;
  productionLocations: any;
  graphLoader: boolean;
  loading: boolean;
  episodelist: any;
  contacts: any;
  productionFormData: any;
  documentlistdept: any;
  contactlistdept: any;
  setactive: any;
  setupcoming: any;
  setcompleted: any;
  setinactive: any;
  page: any;
  setactiverelated: any;
  setcompletedrelated: any;
  setupcomingrelated: any;
  setlistRelated: any;
  totalProductions: any;
  productionsactive: any;
  productionsinactive: any;
  productionsupcoming: any;
  studiolocations: any;
  studioepisodes: any;
  crewListdept: any;
  departmentDetails: any;
  datePickerStatus: any;
  episodeactive: any;

  episodeinactive: any;
  departmentLoading: boolean;
  upcomingepisodes: any;
  access: any;
  estimatedActualSpendingGraph: any;
}

export interface AuthState {
  status: boolean;
  userData: null | any;
  token: null | string;
  apiStatus: string;
  userlist: any;
  isNewUser: any;
  isUserDetailsAdded: boolean;
}
export enum OrderEditOptionValues {
  edit_quantity = 'edit_quantity',
  edit_status = 'edit_status',
  cancel_order = 'cancel_order',
}
export enum ApiStatus {
  idle = 'idle',
  loading = 'loading',
  succeeded = 'succeeded',
  failed = 'failed',
}

export enum OrderRentEditOptionValues {
  approve = 'approve',
  reject = 'reject',
  // edit_quantity = 'edit_quantity',
  edit_status = 'edit_status',
  view_workheet = 'view_workheet',
}
// export enum ModalMode {
//   edit = 'edit',
//   add = 'add',
// }
export const EditOptions = {
  // edit_quantity: {
  //   label: 'Edit Quantity',
  //   value: OrderEditOptionValues.edit_quantity,
  // },
  edit_status: {
    label: 'Edit Delivery Status',
    value: OrderEditOptionValues.edit_status,
  },
  cancel_order: {
    label: 'Cancel Order',
    value: OrderEditOptionValues.cancel_order,
  },
};

export const EditRentOptions = {
  approve: {
    label: 'Approve',
    value: OrderRentEditOptionValues.approve,
  },
  reject: {
    label: 'Reject',
    value: OrderRentEditOptionValues.reject,
  },
};

export const EditRentOptionsWithEditAndStatus = {
  view_workheet: {
    label: 'View Worksheet',
    value: OrderRentEditOptionValues.view_workheet,
  },
  // edit_quantity: {
  //   label: 'Edit Quantity',
  //   value: OrderRentEditOptionValues.edit_quantity,
  // },
  edit_status: {
    label: 'Edit Delivery Status',
    value: OrderRentEditOptionValues.edit_status,
  },
};

export interface ProductState {
  loading: boolean;
  products: null | any;
  error: boolean | string;
}

export interface EditedProductOrder {
  mode: OrderEditOptionValues | null;
  index: number;
  product: any;
}
export enum AddToOrder {
  rent = 'rent',
  purchase = 'purchase',
}
export enum ModalMode {
  edit = 'edit',
  add = 'add',
}

export interface CommissionState {
  loading: boolean;
  commission: null | any;
  error: boolean | string;
  vendorsLists: null | any;
  type: number;
}

export interface OrderState {
  quantity: number;
  departmentList: any;
  loader: boolean;
  shifts: number;
  shiftsError: string;
  businessAddress: null | any;
  orderDetailsLoader: boolean;
  orders: any;
  error: boolean | string;
  page: number;
  filter: null | any;
  searchKeywords: string;
  productOrderList: [] | any;
  vendorlist: [];
  rentProdctsList: any;
  orderDetails: null | any;
  setNameList: any;
  episodeNameList: any;
  locationList: any;
  editedItem: EditedProductOrder | null;
  cancleOrderModalData: {
    isOrderCancle: boolean;
    orderDetails?: any;
  } | null;
  addToOrderType: null | AddToOrder;
  worksheetDetails: any;
  deliveryAddressModalData: {
    mode: ModalMode;
    itemDetails?: any;
  } | null;
  listLoader: {
    setNames: boolean;
    locations: boolean;
    updateAddress: boolean;
  };
  rentalModalDetails: {
    state: boolean;
    itemDetails: any | null;
    formDetails: any;
    cartId: string | null;
    rentalDetails: any;
    rentPriceValue?: string;
  };
  quotationShifts: any;
  qoutationCartDetails: any;
  sortKey: OrderSortKeys;
  sortMode: 1 | -1;
  shiftPreviewData: any;
  /** Incremented when a paginated shift-preview request fails so UI can reset "load more" state */
  shiftPreviewAppendEpoch: number;
  invoiceDetails: any;
  invoiceDetailsLoader: boolean;
  invoicePriceBreakup: any;
  priceBreakupLoader: boolean;
  invoiceItemPriceBreakup: any;
  paymentHistory: any;
  paymentHistoryLoader: boolean;
  invoiceNotes: any;
  invoiceNotesLoader: boolean;
  invoiceReceipt: any;
  invoiceReceiptLoader: boolean;
  invoiceWorksheetData: null;
  expandedWorksheet: null;
  worksheetNotes: null;
}
export interface NotificationFCM {
  from?: string;
  messageId?: string;
  notification?: {
    body?: string;
    title?: string;
  };
  data?: NotificationData;
}

export interface NotificationData {
  chatId?: string;
  senderImage?: string;
  notificationType?: NotificationType;
  senderId?: string;
  messageType?: string;
  message?: string;
  senderType?: string;
  senderName?: string;
  vendorOrderId?: string;
  orderId?: string;
  subNotificationType?: string;
  entityId?: string;
}
export type NotificationType = 'CHAT' | 'ORDER' | 'PAYMENT' | 'INVOICE';

export interface SetState {
  setDetails: any;
  departmentList: any;
  setList: any;
  setSpendingGraph: any;
  setLocations: any;
  graphLoader: boolean;
  loading: boolean;
  episodeList: Array<any>;
  setDetailbanner: any;
  setFormData: any;
  contacts: any;
}

export interface EpisodeState {
  episodeDetails: any;
  departmentList: any;
  episodeList: any;
  episodeSchedule: any;
  episodeGraph: any;
  graphLoader: any;
  episodeLocations: any;
  episodeSetList: any;
  loading: boolean;
  setepisode: any;
  getrole: [];
  episodedeatilbanner: any;
  getrolebyid: any;
  episodeActiveSetList: any;
  episodeInactiveSetList: any;
  episodeUpcomingetList: any;
  episodeFormData: any;
  contacts: any;
}

export interface locationState {
  setDetails: any;
  departmentList: any;
  setList: any;
  locationSpendingGraph: any;
  setLocations: any;
  setLocationsdetails: any;
  setlistLocations: any;
  loading: boolean;
  setEpisodes: any;
  settinglist: any;
  memberdetails: any;
  setlistAddresses: any;
  activeSets: any;
  setlocationBanner: any;
  locationFormData: any;
  contacts: any;
}

export interface SearchParams {
  common: {
    searchParamsForProduction: string;
    searchParamsForEpisode: string;
  };
}

export interface ProductionListApiData {
  productionCount: number;
  episodeCount: number;
  productions: ProductionListData[];
  total: any;
  setCount: number;
}

export interface ProductionListData {
  _id: number;
  name: string;
  type: string;
  memberType: string;
  schedule: Schedule[];
}

export interface Schedule {
  endDate: number;
  scheduleType: string;
  startDate: number;
  _id: number;
}

export interface ProductionListSelector {
  production: {
    productionTableList: ProductionListApiData;
  };
}

export interface ProductionListApi {
  data: {
    data: ProductionListApiData;
  };
}

export interface ProductionListApiError {
  data: {
    statusCode?: string;
  };
}

interface Location {
  type: string;
  coordinates: [number, number];
}

interface DeliveryAddress {
  addressType: string;
  address: string;
  apartment: string | null;
  buildingName: string | null;
  location: Location;
  productionType: string;
  productionId: string;
  productionName: string;
  productionImage: string | null;
  setId: string;
  setName: string;
  setImage: string | null;
  locationId: string;
  locationName: string;
  locationImage: string | null;
  episodeId: string | null;
  episodeName: string | null;
  episodeImage: string | null;
  episodeNumber: string | null;
  movie: string | null;
  productionScheduleType: string;
  setScheduleType: string;
  locationPurpose: string[];
  departmentId: string;
  deptName: string;
  departmentImage: string;
}

export interface Order {
  _id: string;
  comapnyName: string;
  comapnyImage: string;
  totalItems: number;
  price: number;
  vendorOrderId: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  deliveryAddresses: DeliveryAddress[];
  shoppingMode: string[];
  orderStatus: string; // e.g., "INITIATED"
  vendorOrderStatus: string; // e.g., "INITIATED"
  hasRent: boolean;
  hasBuy: boolean;
  orderType: string; // e.g., "Purchase"
}

interface DepartmentListData {
  _id: string;
  deptImage: string;
  deptName: string;
  created: number;
  createdAt: string;
  updatedAt: string;
  userType: string;
  status?: string; // Optional because not all departments have a 'status' field
  documents?: any[]; // Optional, assuming documents could be an array of any type
}

export interface DeptList {
  production: {
    departmentlist: {
      depts: DepartmentListData[];
      deptCount: number;
    };
  };
}

export interface DocumentModalProps {
  open: boolean;
  handleClose: () => void;
  id: string | undefined;
  data?: any;
  module?: any;
  productionName: any;
}

export interface DocumentList {
  _id: string;
  productionId: string;
  entityType: string;
  entityId: string;
  documentAddedByUserId: string;
  deptId: string;
  docName: string;
  docFormat: string;
  documentUrl: string;
  created: number;
  createdAt: string;
  updatedAt: string;
  addedByUser: string;
  urlTitle: string;
}

export interface ContactList {
  _id: string;
  roleName: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  userType: string;
  userId: string;
  isContact: boolean;
  departmentId: string;
}

export interface CrewMemberList {
  _id: string;
  roleName: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  userType: string;
  userId: string;
  isContact: boolean;
  departmentId: string;
}

export interface OrderList {
  comapnyName: string;
  price: number;
  orderType: string;
  orderStatus: string;
  totalItems: number;
  createdAt: string;
  comapnyImage: string;
  _id: string;
}

export interface SetDetailsList {
  schedule: {
    _id: string;
    startDate: number;
    endDate: number;
    scheduleType: string;
  }[];
  image: string;
  sceneDescription: string;
  sceneNumber?: number;
  name: string;
  _id: string;
  locationCount?: number;
}

export interface StaticContentState {
  data: any;
  loading: boolean;
}

export interface RiskCenterState {
  status: boolean;
  apiStatus: string;
  activeEventsData: any;
  activeLocations: any;
  productions: any;
  activeProductions: any;
  inactiveProductions: any;
  upcomingProductions: any;
  userTypeList: any;
  contactList: any;
  userList: any;
  branchDetaildata: any;
  grupsLists: any;
  serviceList: any;
  serviceDetails: any;
  loader: boolean;
  orderList: any;
  accesslist: any;
  businessAddress: any;
  orderLocation: any;
  deliveryCheck: any;
  schdulesTypes: any;
  cartDetails: any;
  cabService: any;
  viewshiftdetails: any;
  similarserviceDetails: any;
  cabBookingDetails: any;
}

export interface StoreState {
  loading: boolean;
  deptsCategories: any;
  preferredVendors: any;
  vendors: any;
  preferredProducts: any;
  preferredServies: any;
  products: any;
  services: any;
  packages: any;
  favorites: any;
  selectedAddress: any;
  preferredPackages: any;
  productDetails: any;
  favoriteData: any;
  serviceDetails: any;
  vendorDetails: any;
  vendorAllDetails: any;
  vendorDetailsGroups: any;
  vendorProducts: any;
  vendorServices: any;
  packageDetails: any;
  groupProducts: any;
  groupServices: any;
  groupPackages: any;
  storeBanner: any;
  productLoading: boolean;
  packageLoading: boolean;
  vendorLoading: boolean;
  serviceLoading: boolean;
  deptsIDs: any;
}

export interface MyDocumentState {
  myDocumentData: any;
  myDocumentLoading: boolean;
  recentLoader: boolean;
  filterEpisodes: any;
  filterSets: any;
  filterLocations: any;
  filterDepartments: any;
  myDocumentError: string;
  recentDocumet: any;
  productionList: any;
  setList: any;
  episodeList: any;
  locationList: any;
  departmentList: any;
  productionDocuments?: any;
}
export interface FilterParams {
  searchKey?: string;
  episodeIds?: string;
  setIds?: string;
  locationIds?: string;
  departmentIds?: string;
  [key: string]: any; // To allow future extensibility (optional)
}

export interface SpendingState {
  spendingData: any;
  spendingOverAllGraphData: any;
  departmentSpendings: any;
  setSpendings: any;
  locationSpendings: any;
  categorySpendings: any;
  vendorSpendings: any;
  orderSpendings: any;
  departmentList: any;
  setList: any;
  locationList: any;
  categoryList: any;
  spendingLoading: boolean;
  episodeSpendings: any;
  overALlGraphLoading: boolean;
  entitySpendingLoading: boolean;
  departmentLoading: boolean;
  setLoading: boolean;
  locationLoading: boolean;
  categoryLoding: boolean;
  vendorLoading: boolean;
  episodeLoading: boolean;
  departmentSpendingData: any;
  departmentOverAllGraphData: any;
  graphAllData: any;
  financeWorksheet: any;
  financeWorksheetLoading: boolean;
  financeWorksheetGroupBy: string;
  financeWorksheetProductId: string;
  financeWorksheetQuickSelect: string;
  financeAddOnCharges: any;
  financeAddOnChargesLoading: boolean;
  financeWorksheetItemNickName: string;
}

export interface Schedular {
  loading: boolean;
  schduleList: any;
}

export interface CartState {
  status: boolean;
  apiStatus: string;
  activeEventsData: any;
  activeLocations: any;
  productions: any;
  activeProductions: any;
  inactiveProductions: any;
  upcomingProductions: any;
  userTypeList: any;
  contactList: any;
  userList: any;
  branchDetaildata: any;
  grupsLists: any;
  serviceList: any;
  serviceDetails: any;
  loader: boolean;
  orderList: any;
  accesslist: any;
  businessAddress: any;
  orderLocation: any;
  deliveryCheck: any;
  schdulesTypes: any;
  cartDetails: any;
  cabService: any;
  viewshiftdetails: any;
  similarserviceDetails: any;
  cabBookingDetails: any;
  setAdressesList: any;
  addMoreItems: any;
  openUpdateModal: boolean;
  loadingOverlay: boolean;
  locationsData: any;
  locations: any;
  poNumber: any;
}

export interface WorksheetItems {
  totalUnits: number;
  totalCost: number;
  setCount: number;
  locationCount: number;
  totalHours: number;
  groups: Group[];
  orderItems: OrderItems;
}

export interface Group {
  // Common
  totalQty: number;
  totalCost: number;
  items: Item[];

  // SET
  setId?: string;
  setName?: string;
  poNumber?: string;

  // LOCATION
  locationId?: string;
  locationName?: string;
  address?: string;

  // EPISODE
  episodeId?: string;
  episodeName?: string;

  // ITEM
  productId?: string;
  productName?: string;
  itemNickName?: string;
  categoryName?: string;

  // DATE
  date?: string;
}

export interface Item {
  _id: string;
  orderId: string;
  vendorOrderId: string;
  userId: string;
  branchId: string;
  productId: string;
  productName: string;
  /** User-given nickname for the order item — shown in place of
   * productName when present (mirrors the finance worksheet's
   * orderItem.itemNickName). */
  itemNickName?: string;
  productionId: string;
  productionName: string;
  qty: number;
  isRushEnable: boolean;
  rushFee: number;
  status: string;
  totalUnits: number;
  created: number;
  isPackage: boolean;
  cartType: string;
  riskCenterUserTypeId: any;
  riskCenterUserId: any;
  notes: any[];
  attachmentUrls: any[];
  categoryId: string;
  categoryName: string;
  categoryImage: string;
  vendorId: string;
  vendorBusinessName: string;
  logoImage: string;
  bgImage: string[];
  bannerImage: string;
  deliveryAddress: WorkSheetDeliveryAddress;
  rateModel: RateModel;
  startTime: string;
  endTime: string;
  shiftCoverage: string;
  shoppingMode: string;
  totalHours: number;
  totalCost: number;
  totalOtHours: number;
  totalDtHours: number;
  OtCost: number;
  DtCost: number;
  totalBilledHours: number;
  deliveryFee: number;
  rushFeeCost: number;
  productInfo: ProductInfo;
  addressType: string;
  address: string;
  location: Location2;
  apartment: any;
  buildingName: any;
  setId: string;
  setName: string;
  locationId: string;
  locationName: string;
  productionType: string;
  episodeId: any;
  episodeName: any;
  episodeNumber: any;
  movie: any;
  productionScheduleType: string;
  setScheduleType: string;
  locationPurpose: string[];
  departmentId: string;
  deptName: string;
  postalCode: string;
  locationsStreet: string;
  country: string;
  rentPricing: RentPricing;
  shift: Shift;
  billableTotalCost: number;
  /** ITEMS groupBy (finance-worksheet-v2) nests the nickname here instead
   * of on the item directly — see itemNickName above. */
  orderItem?: {
    itemNickName?: string;
  };
}

export interface OrderItems {
  productName: string;
  _id: string;
}

export interface WorkSheetDeliveryAddress {
  addressType: string;
  address: string;
  apartment: any;
  buildingName: any;
  location: WorksheetLocation;
  postalCode: string;
  locationsStreet: string;
  country: string;
  productionType: string;
  productionId: string;
  productionName: string;
  productionImage: any;
  setId: string;
  setName: string;
  setImage: any;
  locationId: string;
  locationName: string;
  locationImage: any;
  episodeId: any;
  episodeName: any;
  episodeImage: any;
  episodeNumber: any;
  movie: any;
  productionScheduleType: string;
  setScheduleType: string;
  locationPurpose: string[];
  departmentId: string;
  deptName: string;
  departmentImage: string;
}

export interface WorksheetLocation {
  type: string;
  coordinates: number[];
}

export interface RateModel {
  shiftLength: number;
  rentPrice: number;
  minRateModel: string;
  minDuration: number;
  OTStartTime: number;
  DTStartTime: number;
  baseRate: number;
  extendedPriceMode: string;
  priceMode: string;
  isFlexibleShiftHr: boolean;
  overtimeBillable: boolean;
  _id: string;
}

export interface ProductInfo {
  _id: string;
  title: string;
  images: string[];
  rushFeeCost: number;
}

export interface Location2 {
  type: string;
  coordinates: number[];
}

export interface RentPricing {
  shiftLength: number;
  rentPrice: number;
  minRateModel: string;
  minDuration: number;
  OTStartTime: number;
  DTStartTime: number;
  baseRate: number;
  extendedPriceMode: string;
  priceMode: string;
  isFlexibleShiftHr: boolean;
  overtimeBillable: boolean;
  _id: string;
}

export interface Shift {
  _id: string;
  cartId: string;
  branchId: string;
  unit: number;
  actualStartTime: string;
  actualEndTime: string;
  shiftCoverage: string;
  duration: number;
  cost: number;
  unitCost: number;
  OtDuration: number;
  OtCost: number;
  DtDuration: number;
  DtCost: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  approveBy: string;
  updatedBy: string;
  deliveryAddress: DeliveryAddress2;
  itemType: string;
  shiftDay: string;
  isInvoiceGenerated: boolean;
  invoiceStatus: string;
  billedHours: number;
  mileageCost: number;
  mileageDistance: number;
  mileageRate: number;
  productName: string;
  isFlexibleShiftHr: boolean;
  worksheetId: string;
  orderId: string;
  vendorOrderId: string;
  rushFee: number;
  rushFeeApplied: boolean;
  perDiemCost: number;
  billableOtCost: number;
  billableDtCost: number;
  notes: string[];
  applyPerDiem: boolean;
  firstName: string;
  lastName: string;
  avatarUrl: string;
  billableStartTime: string;
  billableEndTime: string;
  billableCost: number;
  billableDuration: number;
  minShiftLength: number;
  cancellationFee?: number;
}

export interface DeliveryAddress2 {
  addressType: string;
  address: string;
  apartment: any;
  buildingName: any;
  productionType: string;
  productionId: string;
  productionName: string;
  setId: string;
  setName: string;
  locationId: string;
  locationName: string;
  location: Location3;
  productionScheduleType: string;
  setScheduleType: string;
  locationPurpose: string[];
}

export interface Location3 {
  type: string;
  coordinates: number[];
}

export interface WorksheetSummary {
  branchName: string;
  userName: string;
  productionName: string;
}

export interface OrderListState {
  loading: boolean;
  error: boolean;
  orderList: any;
  orderDetails: any;
  pageNo: number;
  returnItemsList: any;
  updatedShifts: any;
  cancelOrderDetails: any;
  updatedShiftsLoading: boolean;
  disputeItems: any;
  orderPermission: any;
  worksheetItems: WorksheetItems;
  worksheetSummary: WorksheetSummary;
}

export interface RiskSecurityState {
  studioDetails: any;
  loading: boolean;
  studioProductionList: any;
  studioLocations: any;
  studioAnalyticsData: any;
  studioAnalyticsDayData: any;
  studioAnlyticsLocationData: any;
  organizations: any;
  threatSubCategory: any;
  reporters: any;
  threatType: any;
  episodeListing: any;
  setListing: any;
  locationsList: any;
  locationSubList: any;
  draftList: any;
  vulnerability: any;
  productions: any;
  loader: boolean;
  productionBasicDetails: any;
  productionAnalytics: any;
  productionSets: any;
  productionAnalyticsData: any;
  productionAnalyticsDayData: any;
  productionAnalyticsLocationData: any;
  productionDashboardLocationThreats: any;
  productionDashboardLocations: any;
  episodeBasicDetails: any;
  episodeAnalyticsData: any;
  episodeAnalyticsDayData: any;
  episodeAnalyticsLocationData: any;
  episodeDashboardLocationThreats: any;
  episodeSets: any;
  setBasicDetails: any;
  setAnalyticsData: any;
  setAnalyticsDayData: any;
  setAnalyticsLocationData: any;
  setDashboardLocationThreats: any;
  locationDetails: any;
  locationThreatAlerts: any;
  setLocations: any;
  setDashboardLocations: any;
  episodeDashboardLocations: any;
  setDashMapLocations: any;
  activeCriticalLocations: any;
  modalLoading: boolean;
  locationLoading: boolean;
  productionDropdownList: any;
  episodeSetDropdownList: any;
  setDropdownList: any;
  locationDropdownList: any;
  riskLoggedInUserDetail: any;
  singleThreatDetail: any;
}

export interface ShoppingModeCount {
  BUY: number;
  RENT: number;
  SERVICE: number;
}
export interface CartProduct {
  shoppingMode?: SHOPPING_MODE;
  finalPrice?: number;
  priceBreakup?: {
    totalCost?: number;
    [key: string]: any;
  };
  qty?: number;
  [key: string]: any;
}

export interface SegregatedCart {
  BUY: CartProduct[];
  RENT: CartProduct[];
  SERVICE: CartProduct[];
  counts: {
    BUY: number;
    RENT: number;
    SERVICE: number;
  };
  totals: {
    BUY: number;
    RENT: number;
    SERVICE: number;
  };
}

export enum FinanceAccessLevel {
  ALLOW = 'ALLOW',
  NONE = 'NONE',
  VIEW = 'VIEW',
}

export enum FinancePermissionType {
  PAYER = 'PAYER',
  APPROVER = 'APPROVER',
  ORDERER = 'ORDERER',
}

export interface InvoiceCardProps {
  invoice: any;
  approvalStatus?: string;
  paymentStatus?: string;
  fromOrder?: boolean;
  listingTitle?: string;
  myApprovalStatus?: string;
  isAll?: boolean;
}

export interface ManageEntityRecordInfo {
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export interface BranchInfo {
  company?: {
    businessAddressLine1?: string;
    businessAddressLine2?: string;
    businessCity?: string;
    businessState?: string;
    businessZipCode?: string;
    businessLocation?: string;
  };
}
